"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCopyPaste = void 0;
const react_1 = require("react");
const clipboard_1 = require("./clipboard");
const dialogs_1 = require("./dialogs");
const defaultIgnoreKeys = ["createdAt", "updatedAt", "id"];
const dataType = process.env["REACT_APP_FIRE_BASE_PROJECT_ID"];
const useCopyPaste = ({ objectType, ignoreKeys = [], }) => {
    const toost = (0, dialogs_1.useToost)();
    const { content, setContent, getContent, clipboardPermission } = (0, clipboard_1.useClipboard)();
    const paste = () => __awaiter(void 0, void 0, void 0, function* () {
        const content = yield getContent();
        console.log({ content });
        if (!objectType || !dataType)
            return;
        if ((content === null || content === void 0 ? void 0 : content.dataType) !== dataType) {
            toost({
                message: "この形式のデータは貼り付けられません。不明なデータ形式です。",
                duration: 3000,
            });
            return;
        }
        if ((content === null || content === void 0 ? void 0 : content.objectType) !== objectType) {
            toost({
                message: `この形式のデータは貼り付けられません。${content === null || content === void 0 ? void 0 : content.objectType}形式のデータが貼り付けられました。`,
                duration: 3000,
            });
            return;
        }
        const data = Object.assign({}, content.data);
        [...defaultIgnoreKeys, ...ignoreKeys].forEach((key) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            delete data[key];
        });
        toost({
            message: "貼り付けました",
            duration: 3000,
        });
        return data;
    });
    const copy = (data) => {
        if (!objectType)
            return;
        setContent({
            objectType,
            data,
            dataType,
        });
        toost({
            message: "コピーしました",
            duration: 3000,
        });
    };
    const canPaste = (0, react_1.useMemo)(() => {
        try {
            if (!clipboardPermission || clipboardPermission === "prompt")
                return true;
            return (objectType &&
                (content === null || content === void 0 ? void 0 : content.objectType) === objectType &&
                (content === null || content === void 0 ? void 0 : content.dataType) === dataType);
        }
        catch (e) {
            return false;
        }
    }, [content, clipboardPermission]);
    return {
        copy,
        paste,
        canPaste,
    };
};
exports.useCopyPaste = useCopyPaste;
